import { Array, Order, pipe } from 'effect'

import type { ModelProperty } from '../../schemas/model/modelProperty.ts'
import type { CoreDslFormLeafPartial } from './schema.ts'

// 保存形 (extra.sortedValues) が string[] なので、数値の選択肢も value を文字列に正規化して突き合わせる
type OrderedSelectOption = Omit<NonNullable<ModelProperty['selectOptions']>[number], 'value'> & { value: string }

interface OrderedComparison {
  operator: '<' | '>' | '<=' | '>='
  options: OrderedSelectOption[]
}

export const getOrderedComparison = (leaf: CoreDslFormLeafPartial): OrderedComparison | undefined => {
  const { left, operator } = leaf
  if (left === undefined || left.type === 'literal' || left.property.type !== 'string') {
    return undefined
  }
  if (operator !== '<' && operator !== '>' && operator !== '<=' && operator !== '>=') {
    return undefined
  }
  const options = left.property.selectOptions ?? []
  if (options.length === 0) {
    return undefined
  }
  const sortedValues = leaf.extra?.sortedValues ?? []
  return {
    operator,
    options: pipe(
      options.map((option) => ({ ...option, value: String(option.value) })),
      Array.dedupeWith((first, second) => first.value === second.value),
      Array.sortBy(
        Order.mapInput(Order.Number, (option) => {
          const index = sortedValues.indexOf(option.value)
          return index < 0 ? sortedValues.length : index
        }),
      ),
    ),
  }
}
